module.exports = __webpack_public_path__ + "static/media/ami_tr.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_tr.png
// module id = 572
// module chunks = 1